module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNCAxNCIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMTQgMTQiPjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+LnN0MHtmaWxsOiMwMDcwRTA7fTwvc3R5bGU+PHBhdGggaWQ9IkxheWVyXzEtMiIgY2xhc3M9InN0MCIgZD0iTTAgMTRsMS4xLTMuMSA4LjEtOC4xLjUuNSAxLjYgMS42LTguMSA4LjEtMy4yIDF6Ii8+PHBhdGggY2xhc3M9InN0MCIgZD0iTTEyLjQ1IDMuNTVsLTItMiAxLjEtMS4xYy42LS42IDEuNS0uNiAyIDAgLjYuNi42IDEuNSAwIDJsLTEuMSAxLjF6Ii8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/static/images/edit.svg
// module id = 730
// module chunks = 0